import type { Score } from "../protocol";
import { t, word, phrases } from "../i18n";

/** A task score as a chip: the total and its band, the parts in the title. */
export function ScoreChip({ score }: { score: Score }) {
  const band = word("recordings:scoreBand", score.band ?? "") ?? score.band;
  const cls = score.total >= 85 ? "chip-live" : score.total >= 50 ? "" : "chip-warn";
  return (
    <span className={`chip ${cls}`} data-testid="score" title={t("recordings:scoreTitle", { version: score.version, count: score.parts?.length ?? 0 })}>
      {phrases.scoreChip(score.total, band)}
    </span>
  );
}
